export class TypedReference {
  constructor(
    public number: string,
    public type: string
  ) {}
}
